import Box from "../../layout/boxes/Box/Box";
import { TableProps, TableSubComponents } from "./Table.types";
import TableBody from "./TableBody/TableBody";
import TableHead from "./TableHead/TableHead";
import TableRow from "./TableRow/TableRow";
import TableCell from "./TableCell/TableCell";
import { StyledTable } from "./Table.styles";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

const Table: React.FC<TableProps> & TableSubComponents = ({
	outlined = true,
	colorOn = "bg_white",
	children,
	className,
	...props
}: TableProps) => {
	const block = new BemIt("Table");

	return (
		<Box overflowX="scroll">
			<StyledTable
				className={addClass(className).after(block)}
				{...props}
				outlined={outlined}
				colorOn={colorOn}
			>
				{children}
			</StyledTable>
		</Box>
	);
};

Table.TableHead = TableHead;
Table.TableCell = TableCell;
Table.TableRow = TableRow;
Table.TableBody = TableBody;

export default Table;
